export default __webpack_public_path__ + "static/media/empty-dashboard.58ddc96d.png";